module.exports = __webpack_public_path__ + "media/images/main_visual_camp_guide-bc382f98077a89aa88ce87fea95122ed.png";